<app-page-heading customTooltip="Back to Applications"
                  [heading]="heading"
                  [backPageName]="backPageName"
                  [hasBackButton]="true"
                  [tabName]="tabName"
                  [customRoute]="customRoute">
</app-page-heading>

<div class="page-container">
  <div class="clearfix">
    <form [formGroup]="generalDetailsForm">
      <div class="flex justify-between items-baseline">
        <div class="col col-2 mr2">
          <div class="flex justify-around items-baseline">
            <div class="col col-3">
              <span><b>Step 1:</b></span>
            </div>
            <div class="col col-9">
              <button mat-raised-button color="primary" (click)="onClickDownload()">
                <mat-icon>arrow_downward</mat-icon>
                 Template
              </button>
            </div>
          </div>
        </div>
        
        <div class="col col-2 mr2">
          <div class="flex justify-around items-baseline">
            <div class="col col-3">
              <span><b>Step 2:</b></span>
            </div>
            <div class="col col-9">
              <mat-form-field class="w-95">
                <mat-label>Employer Group</mat-label>
                <input matInput
                       placeholder="Enter Employer Group"
                       [formControlName]="Controls.EmployerGroup"
                       [matAutocomplete]="employerGroup"
                       (input)="onInputChangedSearchEmployerGroups($event)"
                       (blur)="onEmployerGroupBlur()">
                <mat-autocomplete
                  #employerGroup="matAutocomplete"
                  [panelWidth]="'30vw'"
                  (optionSelected)="onPolicyholderGroupSelected($event.option.value)">
                  <mat-option *ngFor="let option of filteredEmployerGroups"
                              [value]="getDisplayString(option.policyholderGroupNumber, option.name)">
                    {{ getDisplayString(option.policyholderGroupNumber, option.name) }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </div>
        
        <div class="col col-2 mr2">
          <div class="flex justify-around items-baseline">
            <div class="col col-3">
              <span><b>Step 3:</b></span>
            </div>
            <div class="col col-9">
              <mat-form-field class="w-95">
                <mat-label>Broker</mat-label>
                <input matInput
                       placeholder="Enter Broker"
                       [formControlName]="Controls.Broker"
                       [matAutocomplete]="broker"
                       (input)="onInputChangedSearchBrokers($event)"
                       (blur)="onBrokerBlur()">
                
                <mat-autocomplete
                  #broker="matAutocomplete"
                  [panelWidth]="'30vw'"
                  (optionSelected)="onBrokerSelected($event.option.value)">
                  <mat-option *ngFor="let option of filteredBrokers"
                              [value]="getDisplayString(option.brokerNumber, option.name)">
                    {{ getDisplayString(option.brokerNumber, option.name) }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </div>
        
        <div class="col col-2 mr2">
          <div class="flex justify-around items-baseline">
            <div class="col col-3">
              <span><b>Step 4:</b></span>
            </div>
            <div class="col col-9">
              <mat-form-field class="w-95">
                <mat-label>Membership Start Date</mat-label>
                <mat-select [formControlName]="Controls.MembershipStartDate" required>
                  <mat-option *ngFor="let date of startDateOptions" [value]="date.value">
                    {{ date.displayValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        
        <div class="col col-2 mr2">
          <div class="flex justify-around items-baseline">
            <div class="col col-3">
              <span><b>Step 5:</b></span>
            </div>
            <div class="col col-9">
              <button class="m-r-15" mat-raised-button color="primary" (click)="onClickOpenFileExplorer($event)">
                <mat-icon>arrow_upward</mat-icon>
                Upload File
              </button>
              <input id="upload" type="file" [accept]="FILE_EXTENSIONS" (change)="onTemplateFileUpload($event)"
                     style="display: none;"/>
            </div>
          </div>
        </div>
        
        <div class="col col-2 mr2">
          <div class="flex justify-around items-baseline global-container">
            <div class="col col-3">
              <span><b>Step 6:</b></span>
            </div>
            <div class="col col-9">
              <button mat-raised-button color="primary" (click)="onClickSubmitProcessing()">
                Process
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  
  
  <!---------------------------->
  <!-- Divider:-->
  <!---------------------------->
  <mat-divider></mat-divider>

  <div *ngIf="bulkApplications?.applications?.length > 0">
  <div class="flex justify-start m2">
    <label class="column-label">Note: Clicking the process button will process all applications with no validation
      errors</label>
  </div>

  <div class="flex justify-start m-2 w-auto">
    <mat-form-field class="w-auto">
      <mat-select required [(value)]="applicationFilter" (selectionChange)="applyFilter()">
        <mat-option *ngFor="let filter of applicationFilterOptions" [value]="filter">
          {{filter}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <!---------------------------->
  <!-- Table -->
  <!---------------------------->
  <div class="mat-elevation-z8 table-container" >
    <table [dataSource]="dataSource" mat-table matSort multiTemplateDataRows #MatSortBulApplication="matSort">
      <ng-container [matColumnDef]="tableColumns.Actions">
        <th mat-header-cell *matHeaderCellDef class="table-actions-cell" [ngClass]="{ 'extra-left-padding': dataSource?.data?.length=== 0 }"></th>
        <td mat-cell *matCellDef="let app;" class="table-actions-cell">
          <span matTooltip="{{ getApplicationRowErrorMessage(app) }}">
            <button *ngIf="hasValidationErrors(app)" (click)="onEditApplication($event, app)"
                    mat-icon-button>
              <mat-icon class="table-icon icon-orange">warning</mat-icon>
            </button>
          </span>
          <span matTooltip="EDIT Row">
            <button (click)="onEditApplication($event, app)"
                    mat-icon-button>
              <mat-icon class="table-icon">edit</mat-icon>
            </button>
          </span>
          <span matTooltip="DELETE Row">
            <button (click)="onDeleteApplication($event, app)"
                    mat-icon-button>
              <mat-icon class="table-icon">delete</mat-icon>
            </button>
          </span>
        </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.AppRefNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> App Ref #</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.AppRefNumber] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Relationship">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Relationship</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.Relationship] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Title</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.Title] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.Name] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Surname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Surname</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.Surname] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.IdType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID Type</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.IdType] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.IdNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID Number</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.IdNumber] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.DateOfBirth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date of Birth</th>
        <td mat-cell *matCellDef="let app">
          {{ app[tableColumns.DateOfBirth] }}
        </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Gender">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Gender</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.Gender] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.MaritalStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Marital Status</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.MaritalStatus] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Ethnicity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ethnicity</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.Ethnicity] }} </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Option">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Option</th>
        <td mat-cell *matCellDef="let app"> {{ app[tableColumns.Option] }} </td>
      </ng-container>
      
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="displayedColumns.length" mat-cell>
          <div [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <b>Contact Number:</b> {{row.contactNumber}}<br>
            <b>Email Address:</b> {{row.emailAddress}}<br>
            <b>Bank Name:</b> {{row.bankName}}<br>
            <b>Account Number:</b> {{row.accountNumber}}<br>
            <b>Account Type:</b> {{row.accountType}}<br>
            <b>Address Type:</b> {{row.addressType}}<br>
            <b>Address Number:</b> {{row.addressNumber}}<br>
            <b>Address Name:</b> {{row.addressName}}<br>
            <b>Address Suburb:</b> {{row.addressSuburb}}<br>
            <b>Employee Number:</b> {{row.employeeNumber}}<br>
            <b>Employment Date:</b> {{row.employmentDate}}<br>
            <b>Option:</b> {{row.option}}<br>
            <b>Income Amount:</b> {{row.incomeAmount}}<br>
            <b>Broker Code:</b> {{row.brokerCode}}<br>
            <b>Employer Group Code:</b> {{row.employerGroupCode}}<br>
            <b>Membership Start Date:</b> {{row.membershipStartDate}}<br>
            <b>Uploaded By:</b> {{row.uploadedBy}}<br>
            <b>Batch Reference No:</b> {{row.batchReferenceNumber}}<br>
          </div>
        </td>
      </ng-container>
      
      
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr (click)="expandedElement = expandedElement === row ? null : row"
          *matRowDef="let row; columns: displayedColumns;"
          [class.expanded-row]="expandedElement == row" class="row"
          mat-row>
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row" mat-row></tr>
    </table>
    <mat-paginator #MatPaginatorBulkApplication="matPaginator"
                   [pageSizeOptions]="paginatorControls.pageSizeOptions"
                   [pageSize]="paginatorControls.pageSize"
                   showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
  
  <!---------------------------->
  <!-- Empty Placeholder -->
  <!---------------------------->
  
  <section class="m3" *ngIf="!(bulkApplications?.applications && bulkApplications.applications.length > 0)">
    <greydom-obd-capture-placeholder headerText="Import Applications"
                                     buttonText="Download Template"
                                     subtext="Download the template to get started"
                                     (onClick)="onClickDownload()">
    </greydom-obd-capture-placeholder>
  </section>
</div>